import {post} from './fetch'
import {camelCaseObjectKeys, onStatus, shimJson} from './helpers'

export const validateEmail = (email) =>
  post(`/v1/validate-email`, {email}).then(
    onStatus({
      OK: shimJson(camelCaseObjectKeys),
    }),
  )
